/**
 * Shared semantics for the post-procedure waiting state on Home.
 *
 * The page structure is shared across transfer and insemination journeys, but
 * the procedure label, timing language, and curated education must follow the
 * cycle type instead of inheriting IVF copy by default.
 */

export type PostProcedureWaitProcedure =
  "embryo_transfer" | "insemination" | "ovulation_window";
export type PostProcedureWaitContentKey = "transfer" | "fet" | "iui" | "oi";

export type PostProcedureWaitContext = {
  procedure: PostProcedureWaitProcedure;
  contentKey: PostProcedureWaitContentKey;
  /** Optional suffix for the localized wait-specific hero copy. */
  heroCopySuffix: "fet" | "iui" | "oi" | null;
};

export function getPostProcedureWaitContext(
  cycleType: string | null | undefined,
): PostProcedureWaitContext {
  if (cycleType === "fet") {
    return {
      procedure: "embryo_transfer",
      contentKey: "fet",
      heroCopySuffix: "fet",
    };
  }

  if (cycleType === "oi") {
    return {
      procedure: "ovulation_window",
      contentKey: "oi",
      heroCopySuffix: "oi",
    };
  }

  if (cycleType === "iui") {
    return {
      procedure: "insemination",
      contentKey: "iui",
      heroCopySuffix: "iui",
    };
  }

  return {
    procedure: "embryo_transfer",
    contentKey: "transfer",
    heroCopySuffix: null,
  };
}
